import { Record } from 'immutable';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import * as TwoFactorAuthDeviceStatuses from '../constants/TwoFactorAuthDeviceStatuses';
export default class TwoFactorAuthConfig extends Record({
  status: TwoFactorAuthDeviceStatuses.PENDING,
  setupTime: null,
  method: TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR,
  info: null
}) {}